import { createTheme, ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import React, { useState, useEffect } from "react";
import {
    ResponsiveContainer,
    ComposedChart,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Bar,
    Line,
    CartesianGrid,
} from "recharts";

import { earliestYearMonth, getMonthLabelsInRange } from "../../utils/monthRange";
import LoadingOverlay from "../LoadingOverlay";
import CustomLabel from "./CustomLabel";
import CustomTooltip from "./CustomTooltip";

const CumulativeCarrChart = ({ props, onLoad, onDataStart, startMonth, endMonth }) => {
    const [carrData, setCarrData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // Full history is fetched once; the selected month range is applied client-side
    const fetchMetrics = () => {
        setIsLoading(true);
        props
            .fetchData("getcumulativecarr")
            .then((data) => {
                const metricsData = data || [];
                setCarrData(metricsData);
                if (onDataStart) onDataStart(earliestYearMonth(metricsData.map((d) => d.month)));
            })
            .catch((error) => console.error("Error fetching metrics:", error))
            .finally(() => {
                setIsLoading(false);
                if (onLoad) onLoad();
            });
    };

    useEffect(() => {
        fetchMetrics();
    }, []);

    const allowedMonths = getMonthLabelsInRange(startMonth, endMonth);
    const visibleData = carrData.filter((d) => allowedMonths.includes(d.month));

    return (
        <div className="mb-32">
            <h2>Total Cumulative CARR</h2>
            <div className="pt-1">
                {isLoading ? (
                    onLoad ? null : (
                        <LoadingOverlay text="Loading metrics..." />
                    )
                ) : visibleData.length > 0 ? (
                    <ResponsiveContainer width="100%" height={500}>
                        <ComposedChart data={visibleData}>
                            <CartesianGrid stroke="#f5f5f5" />
                            <XAxis dataKey="month" />
                            <YAxis
                                yAxisId="left"
                                domain={[0, 32]}
                                label={{
                                    value: "CARR (Millions)",
                                    angle: -90,
                                    position: "insideLeft",
                                    offset: 10,
                                    style: { textAnchor: "middle", fontSize: 13 },
                                }}
                            />
                            <YAxis
                                yAxisId="right"
                                orientation="right"
                                domain={[0, 100]}
                                label={{
                                    value: "YoY Growth (%)",
                                    angle: 90,
                                    position: "insideRight",
                                    offset: 10,
                                    style: { textAnchor: "middle", fontSize: 13 },
                                }}
                            />
                            <Tooltip content={<CustomTooltip />} />
                            <Legend />
                            <Bar
                                yAxisId="left"
                                dataKey="total_carr"
                                name="Total CARR ($MM)"
                                barSize={20}
                                fill="#156082"
                                label={<CustomLabel data={visibleData} />}
                            />
                            <Line
                                yAxisId="right"
                                type="monotone"
                                name="YoY Growth (%)"
                                dataKey="yoy_growth"
                                stroke="#1d8ec2"
                            />
                        </ComposedChart>
                    </ResponsiveContainer>
                ) : (
                    <h3 className="px-2 pt-8 text-center">No metrics available.</h3>
                )}
            </div>
        </div>
    );
};

export default CumulativeCarrChart;
